<template>
    <div>
        <app-header messages="我" detail="企业简介" pathName="/person/me" pathTo="/person/about"></app-header>
        <!--shopcart-->
        <div class="w">
            <div class="wb">
                <div class="news_show bg_w_s">
                    <h1>企业简介</h1>
                    <div class="news_show_l">
                        <p>租罗记，隶属于上海智兔电子科技有限公司，是国内领先的办公设备租赁服务提供商，同时上海智兔电子科技有限公司核心团队具有丰富的商务租赁、供应链管理和供应链融资经验，同时配备完善的互联网的IT团队以及市场推广团队。</p>
                        <p>我们一直专注于为各类企业提供高品质，低价格的办公电脑、打印机、投影仪等各类办公设备的租赁服务和专业的解决方案。</p>
                        <p>致力于为企业带来优质服务体验：高效率、高品质、灵活、专业！</p>
                    </div>
                    <Right></Right>
                    <div class="clear"></div>
                </div>
            </div>
        </div>
        <!--shopcart end-->

        <app-footer></app-footer>
    </div>
</template>
<script>
    import AppHeader from '../../components/common/Header.vue'
    import AppFooter from '../../components/common/Footer.vue'

    import Right from '../../components/common/Right.vue'

    export default {
        name: "about",
        props:['messages','detail'],
        components: {
            AppHeader,
            AppFooter,

            Right
        }
    }
</script>



// WEBPACK FOOTER //
// src/center/person/about.vue